import { FhirBundleSdk } from "@metriport/fhir-sdk";
import { useMemo } from "react";
import { BaseTableLayout, ColumnDef } from "../../components/base-table-layout";
import { TableRow } from "../../utils/tables-metadata";
import { SurveyRowData } from "./survey-rows";

export type SurveyTableProps = {
  rows: TableRow[];
  onRowClick: (row: TableRow) => void;
  fhirSdk: FhirBundleSdk;
  filterQuery: string;
  onPdfView?: (docId: string) => void;
  isRowViewed?: (row: TableRow) => boolean;
};

export function SurveyTable({ rows, onRowClick, filterQuery, isRowViewed }: SurveyTableProps) {
  function handleRowClick(row: TableRow) {
    onRowClick(row);
  }
  const columns: ColumnDef<SurveyRowData>[] = useMemo(
    () => [
      { key: "observation", header: "Survey Name" },
      { key: "mostRecentValue", header: "Most Recent Value" },
      {
        key: "mostRecentDate",
        header: "Most Recent Date",
        sort: "desc",
        width: "120px",
      },
    ],
    []
  );

  return (
    <BaseTableLayout
      title="Surveys"
      rows={rows as unknown as SurveyRowData[]}
      columns={columns}
      filterQuery={filterQuery}
      onRowClick={handleRowClick}
      isRowViewed={isRowViewed}
    />
  );
}
